<template>
	<!-- .event-inactive -->
	<div slot="no-body" v-if='show' class="full-page-bg-color ">
		<vx-card class="home-card">
			<div class="vx-row no-gutter justify-center items-center">
				<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-full d-theme-dark-bg">
					<div class="p-8 login-tabs-container">
						<template v-if='isEventPending'>
							<div class="vx-col lg:block lg:w-full">
								<div class='reponsive-image'>
									<img
										v-if=" customLogo != '' "
										:src="customLogo"
										alt="login"
										class="mx-auto event-img"
									/>
									<img
										v-else
										src="@/assets/images/pages/maintenance-2.png"
										alt="login"
										class="mx-auto event-img"
									/>
								</div>
							</div>
							<br/>
							<div class="vx-card__title mb-4 justify-center items-center" v-if="timeDiff < 30">
								<h4 class="mb-4" style="text-align: center;">{{ $t('WelcomeEvent') }} <template v-if='event_detail'>{{ event_detail.event_name }}</template></h4>
								<p style="text-align: center;">{{ $t('EventMsg1') }}</p>
								<p style="text-align: center;">{{ $t('EventMsg2') }}</p>
							</div>
							<div class="vx-card__title mb-4 justify-center items-center" v-else>
								<h4 class="mb-4" style="text-align: center;">{{ $t('WelcomeEvent') }} <template v-if='event_detail'>{{ event_detail.event_name }}</template></h4>
								<p
									style="text-align: center;"
								>{{ $t('EventMsg3') }} <template v-if='event_detail'>{{ event_detail.event_name }}</template> {{ $t('EventMsg4') }} {{
										event_detail.event_start_date |
											moment("DD/MM/YYYY")
									}} {{ $t('All') }} {{ event_detail.event_start_date | moment("HH:mm") }}.</p>
							</div>
						</template>
							
						<template v-if="isEventDone">
							<div class="vx-col lg:block lg:w-full">
								<div class='reponsive-image'>
									<img
										v-if="customClosedLogo != ''"
										:src="customClosedLogo"
										alt="login"
										class="mx-auto event-img"
									/>
									<img
										v-else
										src="@/assets/images/pages/maintenance-2.png"
										alt="login"
										class="mx-auto event-img"
									/>
								</div>
							</div>
							<br />
							<div class="vx-card__title mb-4 justify-center items-center">
								<h4 class="mb-4" style="text-align: center">
									{{ $t("WelcomeEvent") }}
									<template v-if="event_detail">{{
										event_detail.event_name
									}}</template>
								</h4>
								<p style="text-align: center">{{ $t("EventDone") }}</p>
							</div>
						</template>
					</div>
				</div>
			</div>
		</vx-card>
		<audio v-if='isEventPending' :src="audioURL" muted autoplay/>
	</div>
</template>

<script>
import moment from "moment";
import { mapGetters } from 'vuex';

export default {
	name: 'EventInactive',
	data() {
		return {
			customLogo: null,
			audioURL: null,
			customClosedLogo: null,
		}
	},
	computed: {
		...mapGetters([
			'event_detail',
			'isModeratorOrAdmin',
			'isSpeaker'
		]),
		show() {
			return this.isEventPending || this.isEventDone
		},
		isEventPending() {
			const event = this.event_detail;
			if(event && event.status == 2)
				return false;
			const show  = event && (event.status == 1 || (event.status == 3 && (this.isSpeaker || this.isModeratorOrAdmin)))
			return !show;
		},
		isEventDone() {
			const event = this.event_detail;
			return event && event.status == 2; // [0,1,3].indexOf(event.status) < 0;
		},
		timeDiff() {
			if(!this.event_detail)
				return null;
			const ms = moment(this.event_detail.event_start_date)
			.diff(moment());
			const dt = moment.duration(ms);
			return Math.floor(dt.asHours()) + moment.utc(ms).format("mm");

			// var now = moment(new Date(), "DD/MM/YYYY HH:mm:ss");
			// var then = moment(new Date(this.event_detail.event_start_date), "DD/MM/YYYY HH:mm:ss");
			// var ms = moment(then, "DD/MM/YYYY HH:mm:ss").diff(
			// 	moment(now, "DD/MM/YYYY HH:mm:ss")
			// );
			// var d = moment.duration(ms);
			// this.timeDiff = Math.floor(d.asHours()) + moment.utc(ms).format("mm");
		}
	},
	created() {
		// this.audioURL = require('@/assets/audio/moricone.mp3');
		this.handleBackgroundMp3Assets();
		this.handleAssets();
		this.handleClosedEventAssets();
	},
	methods: {
		async handleBackgroundMp3Assets() {
			this.$vs.loading()
			try{
				const response = await this.$store.dispatch("GetAssets", "background_mp3");
				this.audioURL = response.data.data.path;
			}catch(error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t('FailedToConfigureAssets'),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
			this.$vs.loading.close();
    },
		async handleAssets() {
			this.$vs.loading()
			try{
				const response = await this.$store.dispatch("GetAssets", "event_not_open")
				this.customLogo = response.data.data.path;
			}catch(error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t('FailedToConfigureAssets'),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
			this.$vs.loading.close();
    },
		async handleClosedEventAssets() {
			try {
				const response = await this.$store.dispatch(
					"GetAssets",
					"event_closed"
				);
				this.customClosedLogo = response.data.data.path;
			} catch (error) {
				console.error(error);
				this.$vs.notify({
					title: this.$t('FailedToConfigureAssets'),
					text: error,
					color: "danger",
					position: "top-center",
				});
			}
			this.$vs.loading.close();
		},
	}
}
</script>
<style lang="scss" scoped>
	.event-img {
		max-width: 600px;
	}
	.reponsive-image {
		position:relative;
		img {
			width:100%;
			height:100%;
		}
	}
</style>